import './sub-task-status-button/sub-task-status-button.component';
import './sub-task-status-button/sub-task-status-button.scss';

import './sub-task-template-form/sub-task-template-form.component';
import './sub-task-template-form/sub-task-template-form.scss';

import './sub-task-template-multi-select/sub-task-template-multi-select.component';
import './sub-task-template-multi-select/sub-task-template-multi-select.scss';

import './sub-task-template-select/sub-task-template-select.component';
import './sub-task-template-select/sub-task-template-select.scss';

import './sub-tasks-templates-table/sub-tasks-templates-table.component';
import './sub-tasks-templates-table/sub-tasks-templates-table.scss';

import './sub-tasks-templates-table-row/sub-tasks-templates-table-row.component';
import './sub-tasks-templates-table-row/sub-tasks-templates-table-row.scss';

import './sub-tasks-templates-view/sub-tasks-templates-view.component';
import './sub-tasks-templates-view/sub-tasks-templates-view.scss';

import './sub-task-template-multi-select-list/sub-task-template-multi-select-list.component';
import './sub-task-template-multi-select-list/sub-task-template-multi-select-list.scss';
